
import Testimonial from "./testimonial";
import Team1 from "./team1";


export default function Team({
    options,
    data
}) {

    const type = options.type;
    if(type === 1) {
        return <Testimonial 
            options={options}
            data={data}
        />
    }

    if(type == 2) {
        return <Team1 
            options={options}
            data={data}
        />
    }

    return <></>
}